import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { isTokenExpire } from "../utils/token";
import {
  // Bars3BottomLeftIcon,
  // Squares2X2Icon,
  // XMarkIcon,
  // MapIcon,
  // UserCircleIcon,
  // BellAlertIcon,
  Cog8ToothIcon,
  // ClipboardDocumentCheckIcon,
  ChartBarSquareIcon,
  // CubeTransparentIcon,
  // DocumentTextIcon,
  ArrowLeftStartOnRectangleIcon,
  BuildingLibraryIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  // UserGroupIcon,
} from "@heroicons/react/24/outline";
// import { Menu, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import Logo from "../assets/mini_logo.png";
import { COLOR_AZUL_MAIN } from "../utils/const/colors-const";
import { STRING_COLOR_PRIMARIO, STRING_FALSE, STRING_LANGUAGE, STRING_NAME_COMPANY, STRING_SIDEBAR_EXPANDED, STRING_TRUE, STRING_URL_LOGO } from "../utils/const/string-const";
import { validarUsuario } from "../api/api-usuario-web";

const getSideBarStatus = () => {
  try {
    const sideBar = localStorage.getItem(STRING_SIDEBAR_EXPANDED);
    if (sideBar !== null) {
      if (sideBar === STRING_FALSE) {
        return false;
      }
      if (sideBar === STRING_TRUE) {
        return true;
      }
    }
    return false;
  } catch (err) {
    return false;
  }
}

function Layout({ children }) {

  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [expireToken, setExpireToken] = useState(true);
  const [expandedMenus, setExpandedMenus] = useState({});
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(getSideBarStatus());
  const [title, setTitle] = useState("DTS");
  const [primaryColor, setPrimaryColor] = useState(COLOR_AZUL_MAIN);
  const [urlLogo, setUrlLogo] = useState(null);

  const sidebarNavigation = [
    { name: t("dashboard"), href: "/dashboard", icon: ChartBarSquareIcon },
    { name: t("manage"), href: "/administer", icon: BuildingLibraryIcon },
    { name: t("settings"), href: "/settings", icon: Cog8ToothIcon },
    { name: t("exit"), href: "/exit", icon: ArrowLeftStartOnRectangleIcon },
  ].map((menuItem) => ({
    ...menuItem,
    getHref: () => (menuItem.primary ? `/` : `/${menuItem.href}`),
    current: function getCurrent(currentPath) {
      return currentPath === this.getHref();
    },
  }));



  const nextPage = (page) => {
    try {
      history.push(`${page}`);
    } catch (err) {
      console.log("nextPage err");
      console.log(err);
    }
  };

  useEffect(() => {
    inicio();
  }, []);

  const inicio = async () => {
    try {
      // console.log('layout');
      const lng = localStorage.getItem(STRING_LANGUAGE);
      if (lng !== null) {
        i18n.changeLanguage(lng);
      }
      const sideBar = localStorage.getItem(STRING_SIDEBAR_EXPANDED);
      if (sideBar !== null) {
        if (sideBar === STRING_FALSE) {
          setIsSidebarExpanded(false);
        }
        if (sideBar === STRING_TRUE) {
          setIsSidebarExpanded(true);
        }
      }

      const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
      if (mainColor !== null) {
        setPrimaryColor(mainColor);
      }

      const urlMainLogo = localStorage.getItem(STRING_URL_LOGO);
      if (urlMainLogo !== null) {
        setUrlLogo(urlMainLogo);
      }

      const nameCompany = localStorage.getItem(STRING_NAME_COMPANY);
      if (nameCompany !== null) {
        setTitle(nameCompany);
      }
      const resp = isTokenExpire();
      if (resp) {
        nextPage("/login");
      } else {
        setExpireToken(false);
      }

      const respValidarUsuario = await validarUsuario();
      if (respValidarUsuario.valido === false) {
        nextPage('/login');
      }

    } catch (err) {
      console.log('inicio err', err);
      nextPage("/login");
    }
  };

  if (expireToken) {
    return <div></div>;
  }

  const handleToggleMenu = (name) => {
    setExpandedMenus((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleToggleSidebar = () => {
    localStorage.setItem(STRING_SIDEBAR_EXPANDED, !isSidebarExpanded);
    setIsSidebarExpanded(prevState => !prevState);
  };

  const renderMenuItems = (items) => {
    // console.log('renderMenuItems');
    // console.log(items);
    return items.map((item, index) => {
      const isExpanded = expandedMenus[item.name];
      return (
        <div key={index}>
          <a
            key={item.name}
            href={item.href}
          >
            <div
              className="flex items-center justify-between p-2 text-gray-700 hover:bg-[#00ABED] cursor-pointer"
              onClick={() => handleToggleMenu(item.name)}
              title={item.name}
            >
              <div className="flex items-center">
                {item.icon && <item.icon className="h-5 w-5 mr-2 text-white" />}
                {isSidebarExpanded && <span className="text-white">{item.name}</span>}
              </div>
              {item.children && item.children.length > 0 && (
                isExpanded ? <ChevronDownIcon className="h-5 w-5" /> : <ChevronRightIcon className="h-5 w-5" />
              )}
            </div>
            <div
              className={`overflow-hidden transition-height ${isExpanded ? 'max-h-96' : 'max-h-0'}`}
              style={{ transitionDuration: '500ms' }}
            >
              {isExpanded && item.children && (
                <div className="ml-4">
                  {renderMenuItems(item.children)}
                </div>
              )}
            </div>
          </a>
        </div>
      );
    });
  };

  return (
    <>
      <div className="flex h-[100vh]">
        <div className={`flex flex-col h-screen transition-width duration-500 ${isSidebarExpanded ? 'w-64' : 'w-20'} `} style={{ backgroundColor: `${primaryColor}` }}>
          <div className="flex items-center justify-between p-4">
            <div className="flex items-center">
              {urlLogo === null &&
                <img className="h-8 w-auto " alt="Logo" src={Logo} />
              }
              {urlLogo !== null &&
                <img className="h-8 w-auto " alt="Logo" src={urlLogo} />
              }
              {isSidebarExpanded && <span className="text-xl font-bold text-white pl-4">{title}</span>}
            </div>
            <button onClick={handleToggleSidebar}>
              {isSidebarExpanded ? <ChevronLeftIcon className="h-5 w-5 text-white" strokeWidth={4} /> : <ChevronRightIcon className="h-5 w-5 text-white" strokeWidth={4} />}
            </button>
          </div>
          <div className="flex-grow p-4 overflow-y-auto">
            {renderMenuItems(sidebarNavigation)}
          </div>
          <div className="p-4 text-gray-500 text-xs">
            Version: 1.1.1
          </div>
        </div>

        {/* Content area */}
        <div className="flex flex-1 flex-col overflow-hidden ">
          <div className="flex flex-1 items-stretch overflow-hidden">
            <aside className=" w-full overflow-y-auto  border-gray-200 bg-white lg:block">
              {children}
            </aside>
          </div>
        </div>

      </div>
    </>
  );
}
export default Layout;
